import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { JobPortalService } from 'src/app/services/job-portal.service';

@Component({
  selector: 'app-modify-location',
  templateUrl: './modify-location.component.html',
  styleUrls: ['./modify-location.component.css']
})
export class ModifyLocationComponent implements OnInit {

  locationList:any = [];
  locationUpdateForm: any | FormGroup
  cid:any
  formSubmit: boolean = false;
  isEdit: boolean = false
  singleLocationData: any = [];
  pageNumber: number = 0;
  totalRecords: number = 0;
  recordsPerPage:number = 10;
  tableSize: number = 10;

  constructor(
    private job_portal_service: JobPortalService,
    private fb: FormBuilder,
    private toastr: ToastrService) { }

  ngOnInit(): void {
    this.cid = sessionStorage.getItem('cid')
    this.getAllLocation();
    this.locationUpdateForm = this.fb.group({
      description: [''],
      isActive: [true],
      country: [''],
      city: [''],
      provinceOrState: [''],
      postalCode: [''],
    })
  }

  onTableDataChange(event: any) {
    this.totalRecords = event;
    this.getAllLocation();
  }

  getAllLocation(){
    this.job_portal_service.getAllLocation().subscribe(
      (res:any)=> {
        console.log(res)
        this.locationList = res.response
      },
      (err:any)=>{
        console.log(err)
      }
    )
  }

  getLocationById(locationId:any){
    this.job_portal_service.getLocationById(locationId).subscribe(
      (response:any)=>{
        this.singleLocationData = []
        this.singleLocationData.push(response.response)
        this.locationUpdateForm.patchValue({
          description: response.response.description,
          country: response.response.country,
          city: response.response.city,
          provinceOrState: response.response.provinceOrState,
          postalCode: response.response.postalCode,
          isActive: response.response.isActive
        })
        this.isEdit = true
      }
    )
  }

  closeEdit(){
    this.isEdit = false
  }


  updateLocation(){
    this.formSubmit = true;
    if(!this.locationUpdateForm.valid){
      return
    }
    let body = {
      "version": this.singleLocationData[0].version,
      "isActive": this.locationUpdateForm.get('isActive').value,
      "description": this.locationUpdateForm.get('description').value,
      "id": this.singleLocationData[0].id,
      "locationId": this.singleLocationData[0].locationId,
      "country": this.locationUpdateForm.get('country').value,
      "city": this.locationUpdateForm.get('city').value,
      "provinceOrState": this.locationUpdateForm.get('provinceOrState').value,
      "postalCode": this.locationUpdateForm.get('postalCode').value,
      "cid": this.cid
    }
    console.log(body)
    this.job_portal_service.updateLocation(body).subscribe(
      (response:any)=>{
        this.isEdit = false
        this.getAllLocation();
        this.formSubmit = false;
        this.locationUpdateForm.reset()
        this.toastr.success(response.message);
      },
      (err:any)=>{
        console.log(err)
        this.toastr.error(err.error.errors[0].description);
      },
    )
  }

}
